import { 
  printReceiptQR, 
  printReceiptBT, 
  printReceiptSerial
} from './printCommands'
import {
  micraSentoNanoSale
} from './micraSentoNanoModel'

const micraNanoDriver = {
  printReceipt: {
    MicraNanoBarcode: async (fiscalReceipt, printSlip, deviceParams, sendMessageToWebView) => {
      return await printReceiptQR(fiscalReceipt, printSlip, micraSentoNanoSale, deviceParams, sendMessageToWebView)
    },
    MicraNanoBT: async (fiscalReceipt, printSlip, deviceParams, sendMessageToWebView) => {
      return await printReceiptBT(fiscalReceipt, printSlip, micraSentoNanoSale, deviceParams, sendMessageToWebView)
    },
    MicraNanoSerial: async (fiscalReceipt, printSlip, deviceParams, sendMessageToWebView) => {
      return await printReceiptSerial(fiscalReceipt, printSlip, micraSentoNanoSale, deviceParams, sendMessageToWebView)
    }
  }
}

export {
  micraNanoDriver
}